<template>
  <div class="mt-3 text-center">
    Sem campos adicionais para produtos
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
